<template>
  <div>
    <spinner :show="loading"/>
    <div v-if="!loading" class="row">
      <div
        v-for="template_type in template_types"
        :key="template_type.key"
        class="col-12 pb-3"
      >
        <b-form-checkbox
          :disabled="!$hasPermission('change_customer')"
          v-model="template_type.subscribed"
          @change="onCheckboxChange"
          switch
        >
          <span class="d-inline-block mb-0">
            {{ template_type.display_name }}
          </span>
        </b-form-checkbox>
      </div>
    </div>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import Spinner from "@/core/components/common/Spinner";
  import CustomerService from "@/modules/customer/CustomerService";
  import _ from 'lodash';

  const {mapState} = createNamespacedHelpers('customer/customerView');

  export default {
    name: "TemplatesUnsubscribe",
    components: {Spinner},
    data() {
      return {
        loading: false,
        initial_template_types: [],
        template_types: [],
      }
    },
    computed: {
      ...mapState({
        customer: state => state.customer,
      }),
    },
    methods: {
      onCheckboxChange: _.debounce(async function () {
        const changedItems = this.template_types
          .filter((t, index) => t.subscribed !== this.initial_template_types[index].subscribed)
          .map((t) => ({
            key: t.key,
            action_type: t.subscribed ? "optin" : "optout",
          }));

        if (changedItems.length === 0) return;

        const response = await CustomerService.createCustomerOptins(this.customer.uuid, {
          source: 'artisio',
          items: changedItems,
        })
        if (response.success) {
          this.$toast('success', this.$t('Notification Opt-in/out were successfully saved'));
          this.initial_template_types = _.cloneDeep(this.template_types);
        } else {
          if (response.body.non_field_errors) {
            this.$errorDialog(response.body.non_field_errors[0])
          }
        }
      }, 1000),
    },
    async beforeMount() {
      this.loading = true;
      let response = await CustomerService.getCustomerOptins(this.customer.uuid);
      this.loading = false;

      if (response.success) {
        this.initial_template_types = _.cloneDeep(response.body);
        this.template_types = response.body;
      }
    },
  }
</script>
